// List Collections, Gift Guide, Editorial

import { buildProducts } from "../components/buildProducts";

(async () => {
    const dropdown_toggles = document.querySelectorAll('.js-dropdown-toggle')

    if (dropdown_toggles.length > 0) {
        for (const dropdown_toggle of dropdown_toggles) {
            dropdown_toggle.addEventListener('click', () => {
                dropdown_toggle.classList.toggle('open')
                dropdown_toggle.nextElementSibling.classList.toggle('hidden')
            })
        }
    }

    const filter_toggle = document.querySelector('.js-filter-toggle')
    const filter_container = document.querySelector('.js-filter-container')
    const filter_close = document.querySelector('.js-filter-close')

    if (filter_toggle) {
        filter_toggle.addEventListener('click', () => {
            filter_container.style.display = 'block'
        })
    }

    if (filter_close) {
        filter_close.addEventListener('click', () => {
            filter_container.style.display = 'none'
        })
    }

    const containers = document.querySelectorAll('.js-collection')

    for (const container of containers) {
        await buildProducts(container);
    }

})()

if (document.querySelector('.js-collection-read-more')) {
    const collectionDescriptions = Array.from(document.querySelectorAll('.collection-description'));
    const readMoreBtns = Array.from(document.querySelectorAll('.js-collection-read-more'));

    collectionDescriptions.forEach((el, index)=>{
        if (el.scrollHeight == el.clientHeight && el.clientHeight > 0) {
            collectionDescriptions[index].classList.remove('collection-description--truncate');
            readMoreBtns[index].classList.add('hidden');
        }
    });

    readMoreBtns.forEach((el, index)=>{
        el.addEventListener('click', (e)=>{
            collectionDescriptions[index].classList.remove('collection-description--truncate');
            readMoreBtns[index].classList.add('hidden');
        });
    });
}
